import { render, staticRenderFns } from "./IntegrationsLastSync.vue?vue&type=template&id=7778f08c"
import script from "./IntegrationsLastSync.vue?vue&type=script&lang=js"
export * from "./IntegrationsLastSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports